import { useDirectReports } from '@bonusly/user-queries';
import { useCurrentUser } from '@bonusly/who-am-i';

export const useCurrentUserReports = () => {
	const user = useCurrentUser();
	const query = useDirectReports(user.id);
	const users = query.data ? query.data.filter((user) => user.deletedAt === null) : [];
	const orderedUsers = users.sort((a, b) => a.displayName.localeCompare(b.displayName));

	return {
		...query,
		data: orderedUsers,
	};
};
